"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmaskValue = exports.VISA_CREDIT_CARD_MASK = exports.AMERICAN_EXPRESS_CREDIT_CARD_MASK = exports.THREE_DIGIT_AREA_CODE_MASK = exports.TWO_DIGIT_AREA_CODE_MASK = exports.LETTERS_MASK = void 0;
exports.LETTERS_MASK = /^[a-zA-ZÀ-ÿ- \u00f1\u00d1]+$/;
exports.TWO_DIGIT_AREA_CODE_MASK = '00 0000 0000';
exports.THREE_DIGIT_AREA_CODE_MASK = '000 000 0000';
exports.AMERICAN_EXPRESS_CREDIT_CARD_MASK = '0000 000000 00000';
exports.VISA_CREDIT_CARD_MASK = '0000 0000 0000 0000';
const unmaskValue = (maskValue = '') => {
    return maskValue.replace(/\D/g, '');
};
exports.unmaskValue = unmaskValue;
//# sourceMappingURL=masks.js.map